import { createContext, useContext } from 'react';

/**
 * GA4 list context for product cards rendered through Page Designer, which cannot receive props
 * from the carousel. Must match the values the carousel sends with `view_item_list`.
 */
export type AnalyticsItemList = {
    itemListId: string;
    itemListName: string;
    /** 0-based position of the card in the list. */
    index?: number;
};

export const AnalyticsItemListContext = createContext<AnalyticsItemList | null>(null);

export function useAnalyticsItemList(): AnalyticsItemList | null {
    return useContext(AnalyticsItemListContext);
}
